export const zh = {
    'E.i': `E.i - 反应/事件（必要时重复）`,
    'E.i.1': `主要来源报告的反应/事件 (E.i.1)`,
    'E.i.3.2': `E.i.3.2 - 事件层面的严重性标准`,
    'LABEL_AE_RPT_DUE': `Report Due Configuration`,
    'AE_EXPECTEDNESS': `Expectedness (AE_EXPECTEDNESS)`,
    'AE_SEVERITY': `Severity (AE_SEVERITY)`,
    'MAT_AE_EXPECTEDNESS': `Expectedness (MAT_AE_EXPECTEDNESS)`,
    'AE_MEDDRA_LLT_NAME': `Reaction / Event(MedDRA Name) (AE_MEDDRA_LLT_NAME)`,
    'AE_ROW_NO_CDMS': `AE Row No. in EDC (AE_ROW_NO_CDMS)`,
    'E.i.1.1a': `主要来源使用母语报告的反应/事件 (E.i.1.1a)`,
    'E.i.1.1b': `主要来源报告的反应/事件的语言类型 (E.i.1.1b)`,
    'E.i.1.2': `主要来源报告反应/事件的翻译 (E.i.1.2)`,
    'E.i.2.1a': `编码反应/事件的MedDRA版本 (E.i.2.1a)`,
    'E.i.2.1b': `反应/事件（MedDRA编码值） (E.i.2.1b)`,
    'E.i.3.1': `由报告者强调的术语 (E.i.3.1)`,
    'E.i.3.2a': `导致死亡 (E.i.3.2a)`,
    'E.i.3.2b': `危及生命 (E.i.3.2b)`,
    'E.i.3.2c': `导致住院/住院时间延长 (E.i.3.2c)`,
    'E.i.3.2d': `残疾/功能丧失 (E.i.3.2d)`,
    'E.i.3.2e': `先天性异常或出生缺陷 (E.i.3.2e)`,
    'E.i.3.2f': `其他重要医学事件 (E.i.3.2f)`,
    'FDA.E.i.3.2h': `Required Intervention (FDA.E.i.3.2h)`,
    'E.i.4': `反应/事件开始日期 (E.i.4)`,
    'E.i.5': `反应/事件结束日期 (E.i.5)`,
    'E.i.6a': `反应/事件持续时间（数字） (E.i.6a)`,
    'E.i.6b': `反应/事件持续时间（单位） (E.i.6b)`,
    'E.i.7': `末次观察到的反应/事件的转归情况 (E.i.7)`,
    'E.i.8': `医疗保健专业人士的医学确认 (E.i.8)`,
    'E.i.9': `发生反应/事件的国家 (E.i.9)`,
    'J2.14.i': `未知・既知 (J2.14.i)`,
    'J2.26.i': `重篤性等 (J2.26.i)`,
    'AE_WHOART_ARRN_CODE': `ARRN Code for Reaction (AE_WHOART_ARRN_CODE)`,
    'AE_WHOART_SEQ_NO': `SEQ Code for Reaction (AE_WHOART_SEQ_NO)`,
    'AE_WHOART_TERM': `WHOART Term for Reaction (AE_WHOART_TERM)`,
    'AE_WHOART_TERM_ENG': `WHOART Term(Eng) for Reaction (AE_WHOART_TERM_ENG)`,
    'C.1.10.r_LABEL': `C.1.10.r - 与本报告相关的报告识别码（必要时重复）`,
    'C.1.10.r': `与本报告相关的报告识别码 (C.1.10.r)`,
    'C.1': `C.1 - 安全性报告的识别`,
    'C.1.11': `报告作废/修订 (C.1.11)`,
    'FDA.C.1.12': 'Combination Product Report Indicator (FDA.C.1.12)',
    'C.1.6': `发送者提交的其他可用文件 (C.1.6)`,
    'C.1.6.1.r': `C.1.6.1.r - 发送者持有的文件（必要时重复）`,
    'C.1.8': `全球唯一病例识别码 (C.1.8)`,
    'C.1.9': `其他病例标识码 (C.1.9)`,
    'C.1.9.1.r': `C.1.9.1.r - 病例识别码的来源（必要时重复）`,
    'C.1.6.1.r.1': `发送者持有的文件 (C.1.6.1.r.1)`,
    'C.1.6.1.r.2': `包含的文件 (C.1.6.1.r.2)`,
    'DOC_FILE_NAME': `包含的文件`,
    'SOURCE_DOCUMENT': `Source Document(s) Upload`,
    'SRC_DOC': `Source Document(SRC_DOC)`,
    'SRC_FILE_CONTENT': `Included Document(SRC_FILE_CONTENT)`,


    'C.1.1': `发送者的（病例）安全报告唯一识别码 (C.1.1)`,
    'C.1.11.1': `报告作废/修正 (C.1.11.1)`,
    'C.1.11.2': `作废/修正的原因 (C.1.11.2)`,
    'C.1.2': `创建日期 (C.1.2)`,
    'C.1.3': `报告类型 (C.1.3)`,
    'C.1.CN.1': '报告来源 (C.1.CN.1)',
    'C.1.CN.2': '报告分类 (C.1.CN.2)',
    'C.1.CN.3': '持有人标识 (C.1.CN.3)',
    'C.1.4': `首次从来源处收到报告的日期 (C.1.4)`,
    'C.1.5': `收到本报告最新信息的日期 (C.1.5)`,
    'C.1.6.1': `是否有附加文件？ (C.1.6.1)`,
    'C.1.7': `该病例是否满足本地加速报告的要求？ (C.1.7)`,
    'FDA.C.1.7.1': `Local Criteria Report Type (FDA.C.1.7.1)`,
    'C.1.8.1': `全球唯一病例识别码 (C.1.8.1)`,
    'C.1.8.2': `病例的首个发送者 (C.1.8.2)`,
    'C.1.9.1': `既往传输时使用的其他病例标识码 (C.1.9.1)`,
    'REPORT_YEAR': `Report Year (REPORT_YEAR)`,
    'EU_REPORT_TYPE': `EudraVigilance Module (EU_REPORT_TYPE)`,
    'FDA_REPORT_TYPE': `FDA Report Type (FDA_REPORT_TYPE)`,
    'J2.1a': `識別番号（報告分類） (J2.1a)`,
    'J2.1b': `識別番号（番号） (J2.1b)`,
    'J2.2.1': `報告起算日 (J2.2.1)`,
    'J2.2.2': `報告起算日に関するコメント (J2.2.2)`,
    'J2.3': `即時報告フラグ (J2.3)`,
    'J2.7.1': `完了、未完了区分 (J2.7.1)`,
    'J2.7.2': `未完了に関するコメント (J2.7.2)`,
    'J2.8.1': `報告対象外フラグ (J2.8.1)`,
    'J2.8.2': `報告対象外の理由 (J2.8.2)`,
    'MFDS_REPORT_TYPE': `MFDS Report Type (MFDS_REPORT_TYPE)`,
    'C.1.9.1.r.1': `病例识别码的来源 (C.1.9.1.r.1)`,
    'C.1.9.1.r.2': `病例识别码 (C.1.9.1.r.2)`,
    'G.k': `G.K - 药物信息`,
    'G.k.2': `Drug Identification (G.k.2)`,
    'G.k.2.1': `药品独特标识符/医药产品标识符 (G.k.2.1)`,
    'G.k.2.2.EU.9.r': `G.k.2.2.EU.9.r - Device component (repeat as necessary)`,
    'G.k.2.3.r': `G.k.2.3.r - 物质/指定物质标识符和规格（必要时重复）`,
    'G.k.3': `持有者和药物的授权/申请编号 (G.k.3)`,
    'G.k.4.r': `G.k.4.r - 剂量信息（必要时重复）`,
    'G.k.7.r': `G.k.7.r - 病例中使用的适应症（必要时重复）`,
    'G.k.9.i': `G.k.9.i - 药物反应/事件矩阵（必要时重复）`,
    'G.k.9.i.2.r': `G.k.9.i.2.r - 药物与反应/事件的相关性评估（必要时重复）`,
    'DG_PRD_KEY': `DG_PRD_KEY`,
    'FDA.G.k.1.a': `FDA Other Characterisation of Drug Role (FDA.G.k.1.a)`,
    'G.k.1': `药物作用特征 (G.k.1)`,
    'G.k.11': `药物的其他信息（自由文本） (G.k.11)`,
    'G.k.2.1.1a': `MPID版本日期/编号 (G.k.2.1.1a)`,
    'G.k.2.1.1b': `医疗产品标识符（MPID） (G.k.2.1.1b)`,
    'G.k.2.1.2a': `PhPID版本日期/编号 (G.k.2.1.2a)`,
    'G.k.2.1.2b': `药品标识符（PhPID） (G.k.2.1.2b)`,
    'G.k.2.2': `主要来源报告的药品名称 (G.k.2.2)`,
    'G.k.2.4': `药品获得国的标识 (G.k.2.4)`,
    'G.k.2.5': `设盲的试验用药 (G.k.2.5)`,
    'G.k.3.1': `上市许可/申请编号 (G.k.3.1)`,
    'G.k.3.2': `上市许可/申请国家 (G.k.3.2)`,
    'G.k.3.3': `持有者/申请者名称 (G.k.3.3)`,
    'G.k.5a': `首次发生反应的累积剂量（数） (G.k.5a)`,
    'G.k.5b': `首次发生反应的累积剂量（单位） (G.k.5b)`,
    'G.k.6a': `暴露时的孕龄（数） (G.k.6a)`,
    'G.k.6b': `暴露时的孕龄（单位） (G.k.6b)`,
    'G.k.8': `针对药物采取的措施 (G.k.8)`,
    'G.k.10.r_TITLE': `G.k.10.r - 药物的额外信息（代码） (必要时重复)`,
    'G.k.10.r': `药物的额外信息（代码） (G.k.10.r)`,
    'FDA.G.k.10a': `FDA Additional Information on Drug (coded) (FDA.G.k.10a)`,
    'FDA.G.k.10.1': `FDA Specialized Product Category (FDA.G.k.10.1)`,
    'G.k.9.i.1': `反应/事件的评估 (G.k.9.i.1)`,
    'G.k.9.i.3.1a': `开始给药至反应/事件开始之间的时间间隔（数） (G.k.9.i.3.1a)`,
    'G.k.9.i.3.1b': `开始给药至反应/事件开始之间的时间间隔（单位） (G.k.9.i.3.1b)`,
    'G.k.9.i.3.2a': `末次给药至反应/事件开始之间的时间间隔（数） (G.k.9.i.3.2a)`,
    'G.k.9.i.3.2b': `末次给药至反应/事件开始之间的时间间隔（单位） (G.k.9.i.3.2b)`,
    'G.k.9.i.4': `再次给药后是否再次发生反应？ (G.k.9.i.4)`,
    'G.k.9.i.2.r.1': `评估的来源 (G.k.9.i.2.r.1)`,
    'G.k.9.i.2.r.2': `评估方法 (G.k.9.i.2.r.2)`,
    'G.k.9.i.2.r.3': `评估结果 (G.k.9.i.2.r.3)`,
    'G.k.9.i.2.r.1.EU.1': `EU Source of Assessment (G.k.9.i.2.r.1.EU.1)`,
    'G.k.9.i.2.r.2.EU.1': `EU Method of Assessment (G.k.9.i.2.r.2.EU.1)`,
    'G.k.9.i.2.r.3.EU.1': `EU Result of Assessment (G.k.9.i.2.r.3.EU.1)`,
    'G.k.9.i.2.r.CN.1': '初始报告人/上市许可持有人评估来源 (G.k.9.i.2.r.CN.1)',
    'G.k.9.i.2.r.CN.2': '评估结果 (G.k.9.i.2.r.CN.2)',
    'G.k.9.i.CN.1': '是否非预期 (G.k.9.i.CN.1)',
    'G.k.9.i.CN.2': '停药或减量后，反应是否消失或减轻 (G.k.9.i.CN.2)',
    'G.k.CN.1': '药品通用名 (G.k.CN.1)',
    'G.k.CN.2': '相关器械 (G.k.CN.2)',
    'G.k.CN.3': '是否为本持有人产品（必要时重复） (G.k.CN.3)',
    'G.k.CN.4': '批准文号/受理号 (G.k.CN.4)',
    'FDA.G.k.12.r': 'FDA.G.k.12.r - Device Information (repeat as necessary)',
    'FDA.G.k.12.r.1': 'Malfunction (FDA.G.k.12.r.1)',
    'FDA.G.k.12.r.2.r_TITLE': 'If follow-up, what type? (repeat as necessary)',
    'FDA.G.k.12.r.2.r': 'If follow-up, what type? (FDA.G.k.12.r.2.r)',
    'FDA.G.k.12.r.3.r_TITLE': 'Device Problem Code (repeat as necessary)',
    'FDA.G.k.12.r.3.r': 'Device Problem Code (FDA.G.k.12.r.3.r)',
    'FDA.G.k.12.r.4': 'Device Brand Name (FDA.G.k.12.r.4)',
    'FDA.G.k.12.r.5': 'Common Device Name (FDA.G.k.12.r.5)',
    'FDA.G.k.12.r.6': 'Device Product Code (FDA.G.k.12.r.6)',
    'FDA.G.k.12.r.7': 'FDA.G.k.12.r.7 - Device Manufacturer',
    'FDA.G.k.12.r.7.1a': 'Device Manufacturer Name (FDA.G.k.12.r.7.1a)',
    'FDA.G.k.12.r.7.1b': 'Device Manufacturer Address (FDA.G.k.12.r.7.1b)',
    'FDA.G.k.12.r.7.1c': 'Device Manufacturer City (FDA.G.k.12.r.7.1c)',
    'FDA.G.k.12.r.7.1d': 'Device Manufacturer State (FDA.G.k.12.r.7.1d)',
    'FDA.G.k.12.r.7.1e': 'Device Manufacturer Country (FDA.G.k.12.r.7.1e)',
    'FDA.G.k.12.r.8': 'Device Usage (FDA.G.k.12.r.8)',
    'FDA.G.k.12.r.9': 'Device Lot Number (FDA.G.k.12.r.9)',
    'FDA.G.k.12.r.10': 'Operator of the Device (FDA.G.k.12.r.10)',
    'FDA.G.k.12.r.11.r_TITLE': 'Remedial Action Initiated (repeat as necessary)',
    'FDA.G.k.12.r.11.r': 'Remedial Action Initiated (FDA.G.k.12.r.11.r)',
    'G.k.9.i.2.r.2.KR.1': `KR Method of Assessment (G.k.9.i.2.r.2.KR.1)`,
    'G.k.9.i.2.r.3.KR.1': `WHO-UMC Result of Assessment (G.k.9.i.2.r.3.KR.1)`,
    'G.k.9.i.2.r.3.KR.2': `KRCT Result of Assessment (G.k.9.i.2.r.3.KR.2)`,
    'G.k.2.2.EU.9.r.1': `Device Component name (free text) (G.k.2.2.EU.9.r.1)`,
    'G.k.2.2.EU.9.r.2': `Device Component TermID version Date/Number (G.k.2.2.EU.9.r.2)`,
    'G.k.2.2.EU.9.r.3': `Device Component TermID (G.k.2.2.EU.9.r.3)`,
    'G.k.2.2.EU.9.r.4': `Device Batch Lot number (G.k.2.2.EU.9.r.4)`,
    'G.k.4.r.10.1': `给药途径（自由文本） (G.k.4.r.10.1)`,
    'G.k.4.r.10.2a': `给药途径术语ID版本日期/编号 (G.k.4.r.10.2a)`,
    'G.k.4.r.10.2b': `给药途径术语ID (G.k.4.r.10.2b)`,
    'G.k.4.r.11.1': `父/母的给药途径（自由文本） (G.k.4.r.11.1)`,
    'G.k.4.r.11.2a': `主要给药途径术语ID版本日期/编号 (G.k.4.r.11.2a)`,
    'G.k.4.r.11.2b': `父/母的给药途径术语ID (G.k.4.r.11.2b)`,
    'G.k.4.r.CN.1': '失效日期/有效期至 (G.k.4.r.CN.1)',
    'G.k.4.r.1a': `剂量（数值） (G.k.4.r.1a)`,
    'G.k.4.r.1b': `剂量（单位） (G.k.4.r.1b)`,
    'G.k.4.r.2': `间隔时间（数值） (G.k.4.r.2)`,
    'G.k.4.r.3': `时间间隔单位的定义 (G.k.4.r.3)`,
    'G.k.4.r.4': `开始给药的日期和时间 (G.k.4.r.4)`,
    'G.k.4.r.5': `末次给药的日期和时间 (G.k.4.r.5)`,
    'G.k.4.r.6a': `给药的持续时间（数值） (G.k.4.r.6a)`,
    'G.k.4.r.6b': `给药的持续时间（单位） (G.k.4.r.6b)`,
    'G.k.4.r.7': `批次/批号 (G.k.4.r.7)`,
    'G.k.4.r.8': `剂量文本 (G.k.4.r.8)`,
    'G.k.4.r.9.1': `药物剂型（自由文本） (G.k.4.r.9.1)`,
    'G.k.4.r.9.2a': `药物剂型术语ID版本日期/编号 (G.k.4.r.9.2a)`,
    'G.k.4.r.9.2b': `药物剂型术语ID (G.k.4.r.9.2b)`,
    'G.k.2.2.EU.1': `Name part - Invented name (G.k.2.2.EU.1)`,
    'G.k.2.2.EU.2': `Name part - Scientific name (G.k.2.2.EU.2)`,
    'G.k.2.2.EU.3': `Name part - Trademark name (G.k.2.2.EU.3)`,
    'G.k.2.2.EU.4': `Name part - Strength name (G.k.2.2.EU.4)`,
    'G.k.2.2.EU.5': `Name part - Form name (G.k.2.2.EU.5)`,
    'G.k.2.2.EU.6': `Name part - Container name (G.k.2.2.EU.6)`,
    'G.k.2.2.EU.7': `Name part - Device name (G.k.2.2.EU.7)`,
    'G.k.2.2.EU.8': `Name part - Intended use name (G.k.2.2.EU.8)`,
    'DI_MEDDRA_LLT_NAME': `Indication(MedDRA Name) (DI_MEDDRA_LLT_NAME)`,
    'G.k.7.r.1': `主要来源报告的适应症 (G.k.7.r.1)`,
    'G.k.7.r.2a': `编码适应症的MedDRA版本 (G.k.7.r.2a)`,
    'G.k.7.r.2b': `适应症（MedDRA编码值） (G.k.7.r.2b)`,
    'DG_IND_KCD_CODE': `KCD Code for Indication (DG_IND_KCD_CODE)`,
    'DG_IND_KCD_VER': `KCD Version for Indication (DG_IND_KCD_VER)`,
    'J2.12': `治験成分記号 (J2.12)`,
    'J2.23.k': `愛称 (J2.23.k)`,
    'J2.24.k': `製品種別 (J2.24.k)`,
    'J2.4.k': `新医薬品等の状況区分 (J2.4.k)`,
    'J2.5.k': `一般用医薬品等のリスク区分等 (J2.5.k)`,
    'J2.6.k': `一般用医薬品等の入手経路 (J2.6.k)`,
    'G.k.2.1.KR.1a': `Medicinal Product Version (G.k.2.1.KR.1a)`,
    'G.k.2.1.KR.1b': `Medicinal Product ID (G.k.2.1.KR.1b)`,
    'G.k.2.3.r.1': `物质/指定物质名称 (G.k.2.3.r.1)`,
    'G.k.2.3.r.2a': `物质/指定物质术语ID版本日期/编号 (G.k.2.3.r.2a)`,
    'G.k.2.3.r.2b': `物质/指定物质术语ID (G.k.2.3.r.2b)`,
    'G.k.2.3.r.3a': `规格（数值） (G.k.2.3.r.3a)`,
    'G.k.2.3.r.3b': `规格（单位） (G.k.2.3.r.3b)`,
    'J2.25.k.r': `成分の区分 (J2.25.k.r)`,
    'G.k.2.3.r.1.KR.1a': `Substance Version (G.k.2.3.r.1.KR.1a)`,
    'G.k.2.3.r.1.KR.1b': `Substance ID (G.k.2.3.r.1.KR.1b)`,
    'D.8.r': `D.8.r - 相关既往用药史（必要时重复）`,
    'D.8.r.EU.r': `D.8.r.EU.r - Substance / Specified Substance Identifier and Strength (repeat as necessary)`,
    'D.8.r.1': `报告的药物名称 (D.8.r.1)`,
    'D.8.r.2a': `MPID版本日期/编号 (D.8.r.2a)`,
    'D.8.r.2b': `医疗产品标识符（MPID） (D.8.r.2b)`,
    'D.8.r.3a': `PhPID版本日期/编号 (D.8.r.3a)`,
    'D.8.r.3b': `药品标识符（PhPID） (D.8.r.3b)`,
    'D.8.r.4': `开始日期 (D.8.r.4)`,
    'D.8.r.5': `停用日期 (D.8.r.5)`,
    'D.8.r.6a': `编码适应症的MedDRA版本 (D.8.r.6a)`,
    'D.8.r.6b': `适应症（MedDRA编码） (D.8.r.6b)`,
    'D.8.r.7a': `编码（不良）反应的MedDRA版本 (D.8.r.7a)`,
    'D.8.r.7b': `（不良）反应（MedDRA编码） (D.8.r.7b)`,
    'DH_MEDDRA_LLT_NAME_AE': `Reaction(MedDRA Name) (DH_MEDDRA_LLT_NAME_AE)`,
    'DH_MEDDRA_LLT_NAME_IND': `Indication(MedDRA Name) (DH_MEDDRA_LLT_NAME_IND)`,
    'D.8.r.1.EU.1': `Name part - Invented name (D.8.r.1.EU.1)`,
    'D.8.r.1.EU.2': `Name part - Scientific name (D.8.r.1.EU.2)`,
    'D.8.r.1.EU.3': `Name part - Trademark name (D.8.r.1.EU.3)`,
    'D.8.r.1.EU.4': `Name part - Strength name (D.8.r.1.EU.4)`,
    'D.8.r.1.EU.5': `Name part - Form name (D.8.r.1.EU.5)`,
    'D.8.r.1.EU.6': `Name part - Container name (D.8.r.1.EU.6)`,
    'D.8.r.1.EU.7': `Name part - Device name (D.8.r.1.EU.7)`,
    'D.8.r.1.EU.8': `Name part - Intended use name (D.8.r.1.EU.8)`,
    'D.8.r.1.KR.1a': `Medicinal Product Version (D.8.r.1.KR.1a)`,
    'D.8.r.1.KR.1b': `Medicinal Product ID (D.8.r.1.KR.1b)`,
    'DH_IND_WHOART_ARRN_CODE': `ARRN Code for Reaction (DH_IND_WHOART_ARRN_CODE)`,
    'DH_IND_WHOART_SEQ_NO': `SEQ Code for Reaction (DH_IND_WHOART_SEQ_NO)`,
    'DH_IND_WHOART_TERM': `WHOART Term for Reaction (DH_IND_WHOART_TERM)`,
    'DH_IND_WHOART_TERM_ENG': `WHOART Term(Eng) for Reaction (DH_IND_WHOART_TERM_ENG)`,
    'D.8.r.EU.r.1': `Substance / Specified Substance Name (D.8.r.EU.r.1)`,
    'D.8.r.EU.r.2a': `Substance/Specified Substance TermID Version Date/Number (D.8.r.EU.r.2a)`,
    'D.8.r.EU.r.2b': `Substance/Specified Substance TermID (D.8.r.EU.r.2b)`,
    'D.8.r.EU.r.3a': `Strength (number) (D.8.r.EU.r.3a)`,
    'D.8.r.EU.r.3b': `Strength (unit) (D.8.r.EU.r.3b)`,
    'D.1.1': `患者医疗记录编号和记录编号的来源（如允许） (D.1.1)`,
    'D.10': `D.10 - 父/母-儿童/胎儿报告，关于父/母的信息`,
    'D.10.2': `父母年龄信息 (D.10.2)`,
    'D.10.2.2': `父母的年龄 (D.10.2.2)`,
    'D.10.7': `父母的相关病史及并发疾病 (D.10.7)`,
    'D.10.7.1.r': `D.10.7.1.r - 父/母的结构化信息（必要时重复）`,
    'D.10.8.r': `D.10.8.r - 父/母的相关既往药物史（必要时重复）`,
    'D.10.8.r.EU.r': `D.10.8.r.EU.r - Substance / Specified Substance Identifier and Strength (repeat as necessary)`,
    'D.2': `年龄信息 (D.2)`,
    'D.2.2': `反应/事件发生时的年龄 (D.2.2)`,
    'D.7': `D.7 - 相关病史及并发疾病（不包括反应/事件）`,
    'D.7.1.r': `D.7.1.r - 相关病史的结构化信息（必要时重复）`,
    'D.9': `D.9 - 死亡病例`,
    'D.9.2.r': `D.9.2.r - 报告的死因（必要时重复）`,
    'D.9.4.r': `D.9.4.r - 尸检-确定的死因（必要时重复）`,
    'LABEL_DM_INDICATION': `Indication`,
    'LABEL_DM_PAT_INFO': `D - 患者特征`,
    'LABEL_DM_REACTION': `Reaction`,
    'D.10.8.r.1': `报告的药物名称 (D.10.8.r.1)`,
    'D.10.8.r.2a': `MPID版本日期/编号 (D.10.8.r.2a)`,
    'D.10.8.r.2b': `医疗产品标识符（MPID） (D.10.8.r.2b)`,
    'D.10.8.r.3a': `PhPID版本日期/编号 (D.10.8.r.3a)`,
    'D.10.8.r.3b': `药品标识符（PhPID） (D.10.8.r.3b)`,
    'D.10.8.r.4': `开始日期 (D.10.8.r.4)`,
    'D.10.8.r.5': `结束日期 (D.10.8.r.5)`,
    'D.10.8.r.6a': `编码适应症的MedDRA版本 (D.10.8.r.6a)`,
    'D.10.8.r.6b': `适应症（MedDRA编码） (D.10.8.r.6b)`,
    'D.10.8.r.7a': `编码反应的MedDRA版本 (D.10.8.r.7a)`,
    'D.10.8.r.7b': `反应（MedDRA编码） (D.10.8.r.7b)`,
    'DHP_MEDDRA_LLT_NAME_AE': `Reaction(MedDRA Name) (DHP_MEDDRA_LLT_NAME_AE)`,
    'DHP_MEDDRA_LLT_NAME_IND': `Indication(MedDRA Name) (DHP_MEDDRA_LLT_NAME_IND)`,
    'D.10.8.r.1.EU.1': `Name part - Invented name (D.10.8.r.1.EU.1)`,
    'D.10.8.r.1.EU.2': `Name part - Scientific name (D.10.8.r.1.EU.2)`,
    'D.10.8.r.1.EU.3': `Name part - Trademark name (D.10.8.r.1.EU.3)`,
    'D.10.8.r.1.EU.4': `Name part - Strength name (D.10.8.r.1.EU.4)`,
    'D.10.8.r.1.EU.5': `Name part - Form name (D.10.8.r.1.EU.5)`,
    'D.10.8.r.1.EU.6': `Name part - Container name (D.10.8.r.1.EU.6)`,
    'D.10.8.r.1.EU.7': `Name part - Device name (D.10.8.r.1.EU.7)`,
    'D.10.8.r.1.EU.8': `Name part - Intended use name (D.10.8.r.1.EU.8)`,
    'D.10.8.r.1.KR.1a': `Medicinal Product Version (D.10.8.r.1.KR.1a)`,
    'D.10.8.r.1.KR.1b': `Medicinal Product ID (D.10.8.r.1.KR.1b)`,
    'D.10.8.r.EU.r.1': `Substance / Specified Substance Name (D.10.8.r.EU.r.1)`,
    'D.10.8.r.EU.r.2a': `Substance/Specified Substance TermID Version Date/Number (D.10.8.r.EU.r.2a)`,
    'D.10.8.r.EU.r.2b': `Substance/Specified Substance TermID (D.10.8.r.EU.r.2b)`,
    'D.10.8.r.EU.r.3a': `Strength (number) (D.10.8.r.EU.r.3a)`,
    'D.10.8.r.EU.r.3b': `Strength (unit) (D.10.8.r.EU.r.3b)`,
    'D.1': `患者（姓名或姓名首字母缩写） (D.1)`,
    'D.1.1.1': `患者医疗记录号和记录号的来源（GP医疗记录号） (D.1.1.1)`,
    'D.1.1.2': `患者医疗记录号和记录号的来源（专家记录编号） (D.1.1.2)`,
    'D.1.1.3': `患者医疗记录号和记录号的来源（医院记录编号） (D.1.1.3)`,
    'D.1.1.4': `患者医疗记录编号和记录编号的来源（研究编号） (D.1.1.4)`,
    'D.10.1': `父/母识别 (D.10.1)`,
    'D.10.2.1': `父/母的出生日期 (D.10.2.1)`,
    'D.10.2.2a': `父/母的年龄（数字） (D.10.2.2a)`,
    'D.10.2.2b': `父/母年龄（单位） (D.10.2.2b)`,
    'D.10.3': `母亲末次月经日期 (D.10.3)`,
    'D.10.4': `父/母的体重（kg） (D.10.4)`,
    'D.10.5': `父/母的身高（cm） (D.10.5)`,
    'D.10.6': `父/母的性别 (D.10.6)`,
    'D.10.7.2': `相关病史及并发疾病的文本说明 (D.10.7.2)`,
    'D.2.1': `出生日期 (D.2.1)`,
    'D.2.2.1a': `胎儿的反应/事件被观察到时的孕龄（数字） (D.2.2.1a)`,
    'D.2.2.1b': `胎儿的反应/事件被观察到时的孕龄（单位） (D.2.2.1b)`,
    'D.2.2a': `反应/事件发生时的年龄（数字） (D.2.2a)`,
    'D.2.2b': `反应/事件发生时的年龄（单位） (D.2.2b)`,
    'D.2.3': `患者年龄层（按报告者） (D.2.3)`,
    'D.CN.1': `民族 (D.CN.1)`,
    'D.CN.2': `种族 (D.CN.2)`,
    'D.CN.3': `医疗机构/经营企业名称 (D.CN.3)`,
    'D.CN.4': `国籍（地区） (D.CN.4)`,
    'D.CN.5': `联系电话 (D.CN.5)`,
    'D.CN.6': `妊娠相关描述 (D.CN.6)`,
    'D.3': `体重（kg） (D.3)`,
    'D.4': `身高（cm） (D.4)`,
    'D.5': `性别 (D.5)`,
    'D.6': `末次月经日期 (D.6)`,
    'D.7.2': `相关病史及并发疾病的文本说明（不包括反应/事件） (D.7.2)`,
    'D.7.3': `合并治疗 (D.7.3)`,
    'D.9.1': `死亡日期 (D.9.1)`,
    'D.9.3': `是否进行尸检？ (D.9.3)`,
    'J2.28': `妊娠の有無 (J2.28)`,
    'DM_AUTOPSY_KCD_CODE': `KCD Code for Autopsy (DM_AUTOPSY_KCD_CODE)`,
    'DM_AUTOPSY_KCD_VER': `KCD Version for Autopsy (DM_AUTOPSY_KCD_VER)`,
    'DM_DEATH_KCD_CODE': `KCD Code for Death (DM_DEATH_KCD_CODE)`,
    'DM_DEATH_KCD_VER': `KCD Version for Death (DM_DEATH_KCD_VER)`,
    'D.9.4.r.1a': `编码尸检-确定的死因的MedDRA版本 (D.9.4.r.1a)`,
    'D.9.4.r.1b': `尸检-确定的死因（MedDRA编码） (D.9.4.r.1b)`,
    'D.9.4.r.2': `尸检-确定的死因（自由文本） (D.9.4.r.2)`,
    'DPS_MEDDRA_LLT_NAME': `Autopsy-determined Cause(s) of Death(MedDRA Name) (DPS_MEDDRA_LLT_NAME)`,
    'D.9.2.r.1a': `编码报告的死因的MedDRA版本 (D.9.2.r.1a)`,
    'D.9.2.r.1b': `报告的死因（MedDRA编码） (D.9.2.r.1b)`,
    'D.9.2.r.2': `报告的死因（自由文本） (D.9.2.r.2)`,
    'DRP_MEDDRA_LLT_NAME': `Reported Cause(s) of Death(MedDRA Name) (DRP_MEDDRA_LLT_NAME)`,
    'D.7.1.r.1a': `编码病史的MedDRA版本 (D.7.1.r.1a)`,
    'D.7.1.r.1b': `病史（疾病/外科手术/等）（MedDRA编码） (D.7.1.r.1b)`,
    'D.7.1.r.2': `开始日期 (D.7.1.r.2)`,
    'D.7.1.r.3': `持续 (D.7.1.r.3)`,
    'D.7.1.r.4': `结束日期 (D.7.1.r.4)`,
    'D.7.1.r.5': `备注 (D.7.1.r.5)`,
    'D.7.1.r.6': `家族史 (D.7.1.r.6)`,
    'MH_MEDDRA_LLT_NAME': `MedDRA Version for Medical History LLT Name(disease / surgical procedure / etc.) (MH_MEDDRA_LLT_NAME)`,
    'MH_KCD_CODE': `KCD Code for Medical History (MH_KCD_CODE)`,
    'MH_KCD_VER': `KCD Version for Medical History (MH_KCD_VER)`,
    'D.10.7.1.r.1a': `编码病史的MedDRA版本 (D.10.7.1.r.1a)`,
    'D.10.7.1.r.1b': `病史（疾病/外科手术/等）（MedDRA编码） (D.10.7.1.r.1b)`,
    'D.10.7.1.r.2': `开始日期 (D.10.7.1.r.2)`,
    'D.10.7.1.r.3': `持续 (D.10.7.1.r.3)`,
    'D.10.7.1.r.4': `结束日期 (D.10.7.1.r.4)`,
    'D.10.7.1.r.5': `备注 (D.10.7.1.r.5)`,
    'FDA.D.11.r_TITLE': 'FDA.D.11.r - Patient Race Code (repeat as necessary)',
    'FDA.D.11.r': 'Patient Race Code (FDA.D.11.r)',
    'FDA.D.12': 'Patient Ethnicity Code (FDA.D.12)',
    'MHP_MEDDRA_LLT_NAME': `MedDRA Version for Medical History LLT Name(Disease / Surgical Procedure / Etc.) (MHP_MEDDRA_LLT_NAME)`,
    'F.r': `F.r - 与患者检查相关的结果（必要时重复）`,
    'F.r.2': `检测名称 (F.r.2)`,
    'F.r.3': `检测结果 (F.r.3)`,
    'F.r.1': `检查日期 (F.r.1)`,
    'F.r.2.1': `检查项（自由文本） (F.r.2.1)`,
    'F.r.2.2a': `编码检查项的MedDRA版本 (F.r.2.2a)`,
    'F.r.2.2b': `检查项（MedDRA编码数值） (F.r.2.2b)`,
    'F.r.3.1': `检查结果（代码） (F.r.3.1)`,
    'F.r.3.2': `检查结果（值/限定符） (F.r.3.2)`,
    'F.r.3.3': `检查结果（单位） (F.r.3.3)`,
    'F.r.3.4': `非结构化的检查结果（自由文本） (F.r.3.4)`,
    'F.r.4': `正常范围最低值 (F.r.4)`,
    'F.r.5': `正常范围最高值 (F.r.5)`,
    'F.r.6': `备注（自由文本） (F.r.6)`,
    'F.r.7': `更多的可用信息 (F.r.7)`,
    'LB_MEDDRA_LLT_NAME': `Test Name(MedDRA Name) (LB_MEDDRA_LLT_NAME)`,
    'C.4.r': `C.4.r - 文献引用`,
    'C.4.r.1': `文献引用 (C.4.r.1)`,
    'C.4.r.2': `包含的文件 (C.4.r.2)`,
    'LIT_FILE_NAME': `包含的文件`,


    'J2.15.r': `公表国 (J2.15.r)`,
    'J2.17.r': `試験／研究の分類 (J2.17.r)`,
    'H_TITLE': `H - 叙述病例总结和其他信息`,
    'H.3.r': `H.3.r - 发送者的诊断（必要时重复）`,
    'H.5.r': `H.5.r - 用母语撰写的病例摘要和报告者的评论（必要时重复）`,
    'LABEL_NR_RE_EXAM_RECEIVE': `Re-examination report received history`,
    'LABEL_NR_RE_EXAM_REQUEST': `Re-examination report draft & request history`,
    'LABEL_NR_RE_EXAM_TITLE': `Re-examination History`,
    'EXIJ_COMMENT': `コメント (EXIJ_COMMENT)`,
    'EXIJ_END_DATE': `調査終了日 (EXIJ_END_DATE)`,
    'EXAJ_CREATE_DATE': `調査票作成日 (EXAJ_CREATE_DATE)`,
    'EXAJ_DEADLINE': `調査期限日 (EXAJ_DEADLINE)`,
    'EXAJ_RCV_DATE': `調査票入手日 (EXAJ_RCV_DATE)`,
    'EXAJ_RCV_FILE_CONTENT': `入手調査票の送付 (EXAJ_RCV_FILE_CONTENT)`,
    'EXAJ_RCV_FILE_NAME': `入手調査票の送付 (EXAJ_RCV_FILE_NAME)`,


    'EXAJ_REQ_DATE': `調査依頼日 (EXAJ_REQ_DATE)`,
    'EXAJ_REQ_FILE_CONTENT': `作成調査票の送付 (EXAJ_REQ_FILE_CONTENT)`,
    'EXAJ_REQ_FILE_NAME': `作成調査票の送付 (EXAJ_REQ_FILE_NAME)`,


    'EXAJ_TYPE': `作成・入手調査票の種類 (EXAJ_TYPE)`,
    'H.5.r.1a': `病例总结和报告者评论文本 (H.5.r.1a)`,
    'H.5.r.1b': `病例总结和报告者的注释语言 (H.5.r.1b)`,
    'H.1': `病例叙述包括临床病程、治疗措施、结果及其他相关信息 (H.1)`,
    'H.2': `报告者的评论 (H.2)`,
    'H.4': `发送者的评论 (H.4)`,
    'NR_SPONSOR': `Additional Information (NR_SPONSOR)`,
    'J2.10': `今後の対応 (J2.10)`,
    'J2.11': `その他参考事項等 (J2.11)`,
    'J2.16': `報告内容の要点 (J2.16)`,
    'J2.19': `備考1 (J2.19)`,
    'J2.20': `備考2 (J2.20)`,
    'J2.21': `備考3 (J2.21)`,
    'J2.22': `備考4 (J2.22)`,
    'J2.9': `感染症の遡及調査 (J2.9)`,
    'DIA_MEDDRA_LLT_NAME': `Sender's Diagnosis / Syndrome and / or Reclassification of Reaction / Event(MedDRA Name) (DIA_MEDDRA_LLT_NAME)`,
    'H.3.r.1a': `针对发送者诊断/症状和（或）反应/事件重新分类的MedDRA版本 (H.3.r.1a)`,
    'H.3.r.1b': `发送者诊断/症状和（或）对不良反应/事件的重新分类（MedDRA编码数值） (H.3.r.1b)`,
    'J2.18': `受信者情報 (J2.18)`,
    'LABEL_RE_INFORMATION_ON_RECEIVER': `INFORMATION ON RECEIVER OF CASE SAFETY REPORT`,
    'J2.18.1': `受信者組織名 (J2.18.1)`,
    'J2.18.2': `受信者職名 (J2.18.2)`,
    'J2.18.3': `受信者姓 (J2.18.3)`,
    'J2.18.4': `受信者名 (J2.18.4)`,
    'RD_RECEIVER': `Receiver (RD_RECEIVER)`,
    'RD_RPT_DATE': `Reported Date (RD_RPT_DATE)`,
    'RD_RPT_DUE': `Report Due (RD_RPT_DUE)`,
    'C.2.r': `C.2.r - 信息的主要来源`,
    'C.2.r.1': `报告者的名字 (C.2.r.1)`,
    'C.2.r.2': `报告者的地址和电话 (C.2.r.2)`,
    'C.2.r.1.1': `报告者的称呼 (C.2.r.1.1)`,
    'C.2.r.1.2': `报告者的名字 (C.2.r.1.2)`,
    'C.2.r.1.3': `报告者的中间名 (C.2.r.1.3)`,
    'C.2.r.1.4': `报告者的姓氏 (C.2.r.1.4)`,
    'C.2.r.2.1': `报告者所在机构 (C.2.r.2.1)`,
    'C.2.r.2.2': `报告者所在部门 (C.2.r.2.2)`,
    'C.2.r.2.3': `报告者所在街道地址 (C.2.r.2.3)`,
    'C.2.r.2.4': `报告者所在城市 (C.2.r.2.4)`,
    'C.2.r.2.5': `报告者所在州或省 (C.2.r.2.5)`,
    'C.2.r.CN.1': `电子邮箱 (C.2.r.CN.1)`,
    'C.2.r.2.6': `报告者的邮政编码 (C.2.r.2.6)`,
    'C.2.r.2.7': `报告者的电话 (C.2.r.2.7)`,
    'C.2.r.3': `报告者的国家代码 (C.2.r.3)`,
    'C.2.r.4': `报告者资质 (C.2.r.4)`,
    'C.2.r.5': `基于监管目的的主要来源 (C.2.r.5)`,
    'J2.27.r': `日付フラグ (J2.27.r)`,
    'J2.29.r': `情報入手元 (J2.29.r)`,
    'C.2.r.4.KR.1': `Other Health professional Type (C.2.r.4.KR.1)`,
    'FDA.C.2.r.2.8': `Reporter's Email (FDA.C.2.r.2.8)`,
    'C.3': `C.3 - 安全性报告发送者的信息`,
    'C.3.3': `负责传输报告的人员 (C.3.3)`,
    'C.3.4': `发送者的地址、传真、电话和邮箱地址 (C.3.4)`,
    'C.3.1': `发送者类型 (C.3.1)`,
    'C.3.2': `发送者所在机构 (C.3.2)`,
    'C.3.3.1': `发送者所在部门 (C.3.3.1)`,
    'C.3.3.2': `发送者的称谓 (C.3.3.2)`,
    'C.3.3.3': `发送者的名字 (C.3.3.3)`,
    'C.3.3.4': `发送者的中间名 (C.3.3.4)`,
    'C.3.3.5': `发送者的姓氏 (C.3.3.5)`,
    'C.3.4.1': `发送者的街道地址 (C.3.4.1)`,
    'C.3.4.2': `发送者所在城市 (C.3.4.2)`,
    'C.3.4.3': `发送者所在州或省 (C.3.4.3)`,
    'C.3.4.4': `发送者的邮政编码 (C.3.4.4)`,
    'C.3.4.5': `发送者的国家代码 (C.3.4.5)`,
    'C.3.4.6': `发送者的电话号码 (C.3.4.6)`,
    'C.3.4.7': `发送者的传真号码 (C.3.4.7)`,
    'C.3.4.8': `发送者的邮箱地址 (C.3.4.8)`,
    'C.3.1.KR.1': `Health Professional Type (C.3.1.KR.1)`,
    'C.5': `C.5 - 研究识别信息`,
    'C.5.1.r': `C.5.1.r - 研究注册（必要时重复）`,
    'J2.13.r': `J2.13.r - 治験の概要`,
    'C.5.2': `研究名称 (C.5.2)`,
    'C.5.3': `申办者研究编号 (C.5.3)`,
    'C.5.4': `发现该反应/事件时的研究的类型 (C.5.4)`,
    'C.5.4.KR.1': `Other Studies Type (C.5.4.KR.1)`,
    'C.5.1.r.1': `研究注册编号 (C.5.1.r.1)`,
    'C.5.1.r.2': `研究注册国家 (C.5.1.r.2)`,
    'FDA.C.5.5a': 'IND Number where AE Occurred (FDA.C.5.5a)',
    'FDA.C.5.5b': 'Pre-ANDA Number where AE Occurred (FDA.C.5.5b)',
    'FDA.C.5.6.r_TITLE': 'FDA.C.5.6.r - IND number of cross reported IND (repeat as necessary)',
    'FDA.C.5.6.r': 'IND number of cross reported IND (FDA.C.5.6.r)',
    'J2.13.r.1': `届出回数 (J2.13.r.1)`,
    'J2.13.r.2': `対象疾患 (J2.13.r.2)`,
    'J2.13.r.3': `開発相 (J2.13.r.3)`,
    'J2.13.r.4': `投薬中の症例の有無 (J2.13.r.4)`,
    'RE': `Information on Receiver of Case Safety Report`,
    'RE.REPORT_DUE': `Report Due and Reported Date`,
    'WF': `Route a Case to the Next Workflow Step`,
    'AT': `Audit Trail`,
    message: {
        all: 'ALL',
        hello: '하오하오',
        noMatchText: 'Not matched.',
        noDataText: 'No data',
        noDataToDisplayText: 'No data to display.',
        logout: 'Log out',
        success: 'Success',
        warning: 'Warning',
        repeatRowNo: 'No.{rowNo}',
        goto: 'Go to',
        header: {
            system: 'System'
        },
        error: {
            forbidden: 'There is no privilege to access.',
            back: 'Back to Previous Page',
            exceedFileSize: 'The file is too large. Allowed maximum size is %sMB.',
            noticeExceedFileSize: 'The maximum file size that can be uploaded is 5MB.',
            unexpectedError: 'An error has occurred. Please contact system administrator.',
        },
        placeholder: {
            systemAutoInput: 'Automatic input by system',
            autocomplete: 'Autocomplete',
            autocombo: 'Autocombo',
        },
        fileUploadDialog: {
            searchFile: 'Search File'
        },
        discardConfirmDialog: {
            title: 'Discard Confirm',
            message: 'Discard changes?',
        },
        sessionTimeoutDialog: {
            title: 'Log out Confirm',
            message: `After <span class="color-fa2710">5min. (300 sec)</span> you will be <span class="color-fa2710">logged out</span> automatically.`,
            ignore: 'Ignore',
            extend: 'Extend',
            sessionWillBeExpired: 'Session will be expired.',
        },
        commonValidator: {
            required: 'This field is required.',
            invalid: 'This value is not valid.',
            invalidUserId: 'Invalid User Id.',
        },
        commonReasonDialog: {
            title: 'Confirm',
            content: 'Do you want to save your changes?<br>Please enter your reason why did changed.',
            inputError: 'Input Error',
            newData: 'New Data',
            editedData: 'Edited Data',
            others: 'Others',
            noModifyData: 'There is no modified data.',
            required: 'Please enter the reason for the modification.',
        },
        commonPaginatedTable: {
            no: 'No.',
            selectAll: 'Select All',
        },
        caseTopMenuAuditTrailDialog: {
            status: 'Status',
            reason: 'Reason',
            dateTime: 'Date/Time',
            user: 'User'
        },
        auditTrailDialog: {
            title: 'Audit Trail',
            dateTime: 'Date/Time',
            user: 'User',
            item: 'Item',
            value: 'Value',
            notation: 'Notation',
            nullFlavor: 'NullFlavor',
            reason: 'Reason',
        },
        submissionCommentUpdateDialog: {
            title: 'Status and Comments',
            description: `The Status can only be changed if it is 'Delayed' or 'ACK...(M)'.<br/>
                          (If an actual ACK is received, it will automatically update with that result).`,
            no: 'No.',
            itemLabel: 'Item Label',
            status: 'Status',
            value: 'Value',
            comments: 'Comments',
            reason: 'Reason',
            dateTime: 'Date/Time',
            userId: 'UserId',
            user: 'User',
        },
        itemAuditTrailDialog: {
            title: 'Status and Comments',
            no: 'No.',
            itemLabel: 'Item Label',
            value: 'Value',
            comments: 'Comments',
            reason: 'Reason',
            dateTime: 'Date/Time',
            userId: 'UserId',
            user: 'User',
        },
        initializeConfirmDialog: {
            title: 'Confirm',
            content: 'Are you sure to you want to initialize the mapping rule?'
        },
        loadConfirmDialog: {
            title: 'Confirm',
            content: 'Are you sure to you want to load the mapping rule?'
        },
        reviewConfirmDialog: {
            title: 'Confirm',
            content: 'Are you sure you want to review the case?'
        },
        unReviewConfirmDialog: {
            title: 'Confirm',
            content: 'Are you sure you want to cancel the case review? '
        },
        lockConfirmDialog: {
            title: 'Confirm',
            content: 'Are you sure you want to lock the case?'
        },
        unLockConfirmDialog: {
            title: 'Confirm',
            content: 'Are you sure you want to unlock the case?'
        },
        downloadConfirmDialog: {
            title: 'Confirm',
            content: 'Are you sure you want to proceed with downloading the displayed list?'
        },
        followUpConfirmDialog: {
            title: 'Confirm',
            content: 'Are you sure you want to create a follow-up case?'
        },
        makeEditorTableDialog: {
            title: 'Make Table',
            rows: 'Rows',
            columns: 'Columns',
            withHeaderRow: 'With Header Row',
            validationMessage: 'This field is required. Please Input 1~10'
        },
        inputUrlDialog: {
            title: 'Insert Link',
            url: 'URL'
        },
        reviewListConfirmDialog: {
            title: 'Confirm',
            content: 'Are you sure you want to review the selected case(s)?'
        },
        cancelReviewListConfirmDialog: {
            title: 'Confirm',
            content: 'Are you sure you want to cancel the case review for the selected case(s)? '
        },
        lockListConfirmDialog: {
            title: 'Confirm',
            content: 'Are you sure you want to lock the selected case(s)?'
        },
        unLockListConfirmDialog: {
            title: 'Confirm',
            content: 'Are you sure you want to unlock the selected case(s)?'
        },
        selectedAeSyncsConfirmDialog: {
            title: 'Confirm',
            content: 'Are you sure to you want to sync the selected AE(s)?',
            warning: 'The Booklet Status of some rows selected is not Complete. Are you sure you want to proceed with batch sync?'
        },
        aiCodingUpdateConfirmDialog: {
            title: 'Confirm',
            content: `Are you sure you want to proceed with updating for the {totalRow} selected row(s)?`,
            enteredElement: `The value below will be entered in '{targetElement}'.`,
            whoddVersion: `WHODD Short Version: {whoddVersion}`,
        },
        noResultsAiCodingConfirmDialog: {
            title: 'Confirm',
            content: 'There is no AI recommended code with that information.',
        },
        missingItemAiCodingConfirmDialog: {
            title: 'Confirm',
            content: `AI coding conditions have not been met.<br /><br />
                      {errMsg}`,
        },
        productRecommendedCodeInfoDialog: {
            title: 'AI Coding Detail',
            confirm: 'Confirm',
            more: 'More',
            columns: {
                medicinalProductID: 'Medicinal Product ID',
                drugCode: 'Drug Code',
                drugName: 'Drug Name',
                nameSpecifier: 'Name Specifier',
                ingredients: 'Ingredients',
                generic: 'Generic',
                preferred: 'Preferred',
                country: 'Country',
                mah: 'MAH',
                pharmForm: 'Pharm Form',
                strength: 'Strength',
                preferredName: 'Preferred Name',
                selAtcCode: 'Sel ATC Code',
                selAtcName: 'Sel ATC Name',
                atcCode: 'ATC Code',
                atcName: 'ATC Name',
            },
        },
        whoddSubstanceRecommendedCodeInfoDialog: {
            title: 'AI Coding Detail',
            confirm: 'Confirm',
            more: 'More',
            columns: {
                substanceName: 'Substance Name',
                casNumber: 'Cas Number'
            }
        },
        mfdsProductRecommendedCodeInfoDialog: {
            title: 'AI Coding Detail',
            confirm: 'Confirm',
            more: 'More',
            columns: {
                koreanTerm: 'Korean Term',
                code: 'Code',
                status: 'Status',
                date: 'Date',
            }
        },
        mfdsSubstanceRecommendedCodeInfoDialog: {
            title: 'AI Coding Detail',
            confirm: 'Confirm',
            more: 'More',
            columns: {
                term: 'Term',
                englishTerm: 'English Term',
                code: 'Code',
            }
        },
        batchWorkflowDialog: {
            title: 'Route Cases to the Next Workflow Step',
            currentStatus: 'Current Status',
            routeToNextStatus: 'Route to Next Status',
            role: 'Role',
            user: 'User',
            comment: 'Comments',
        },
        button: {
            add: 'Add',
            save: 'Save',
            download: 'Download',
            email: 'E-MAIL',
            close: 'Close',
            ok: 'Ok',
            cancel: 'Cancel',
            confirm: 'Confirm',
            clear: 'Clear',
            clearFilter: 'Clear Filters',
            fullText: 'FULL TEXT',
            more: 'MORE',
            today: 'Today',
            done: 'Done',
            followUp: 'Follow-Up',
            submissionButton: 'Submission',
            delete: 'Delete',
            restore: 'Restore',
            list: 'List',
            edit: 'Edit',
            template: 'Template',
            upload: 'Upload',
            fileUpload: 'File Upload',
            run: 'Run',
            search: 'Search',
            changePassword: 'Change Password',
            myInfo: 'My Info',
            onlineManual: 'Online Manual',
            helpCenter: 'Help Center',
            privacyPolicy: 'Privacy Policy',
            library: 'Library',
            send: 'Send',
            sync: 'Sync',
            reset: 'Reset',
            system: 'System',
            status: {
                review: 'Review / Cancel Review',
                lock: 'Lock / Unlock',
                delete: 'Delete / Restore',
                workflow: 'Route Cases by Workflow',
            },
            noticePopupDoNotRemind: {
                tomorrow: 'Don\'t remind me until tomorrow.',
                again: 'Don\'t remind me again.',
            },
        },
        datePicker: {
            placeholder: {
                datetime: 'Select date and time',
                date: 'Select Date',
                time: 'Select Time'
            },
            invalidFormatMessage: 'You have entered an invalid date format. please check.'
        },
        login: {
            signIn: 'Sign In',
            userId: 'USER ID',
            password: 'PASSWORD',
            findPassword: 'Find Password',
            systemAccess: 'SYSTEM ACCESS',
            helpDesk: 'HELP DESK',
            copyright: 'COPYRIGHT CRSCUBE INC. ALL RIGHTS RESERVED.',
            selectSponsor: 'Select Sponsor',
            selectSponsorWarningUnsaved: 'You have unsaved changes that will be lost.',
        },
        findPassword: {
            title: 'Find Your Password',
            email: 'Please enter your E-mail',
            find: 'Find',
        },
        setUpPassword: {
            title: 'Set-up Password',
            notification: 'Please Set up your password on your discretion.',
            userId: 'USER ID',
            newPassword: 'NEW PASSWORD',
            confirmPassword: 'CONFIRM PASSWORD',
            save: 'SAVE',
            passwordFormatNotMatched: 'A password must be eight characters including one numeric value, and one alphabetic character.',
            confirmPasswordNotMatched: 'The confirm password should be identical with the new password.',
        },
        home: {
            noticeTitle: 'NOTICE',
            more: 'MORE',
            title: 'Title',
            date: 'Date',
            writer: 'Writer',
            caseReportingDeadlineIsApproachingTitle: 'CASE(S) REPORTING DEADLINE IS APPROACHING',
            receiver: 'Receiver',
            aeName: 'AE Term',
            productName: 'DG_PRD_KEY',
            caseNo: 'Case No.',
            dDay: 'D-Day',
            edcSyncStatusTitle: 'EDC SYNC STATUS',
            study: 'Study',
            syncCount: 'Sync Count',
            topMenu: {
                notice: 'NOTICE',
                caseReportingDeadlineIsApproaching: 'CASE(S) REPORTING DEADLINE IS APPROACHING',
                edcSyncStatus: 'EDC SYNC LIST',
            },
            notice: {
                title: 'Title',
                effectiveDate: 'Effective date',
                systemNotice: 'System Notice',
                email: 'E-mail',
                country: 'Country',
                deleted: 'Deleted',
                content: 'Content',
                attachment: 'Attachment',
                popup: 'Popup',
                editor: {
                    tooltip: {
                        bold: 'Bold',
                        unorderedList: 'Unordered List',
                        codeBlock: 'Code Block',
                        codeLine: 'Code Line',
                        fontColor: 'Font Color',
                        highlight: 'Highlight',
                        horizontalRule: 'Horizontal Rule',
                        hyperLink: 'Hyper Link',
                        italic: 'Italic',
                        orderedList: 'Ordered List',
                        paragraph: 'Paragraph',
                        strike: 'Strike',
                        taskList: 'Task List',
                        textCenterAlign: 'Text Center Align',
                        textLeftAlign: 'Text Left Align',
                        textRightAlign: 'Text Right Align',
                        makeTable: 'Make Table',
                        addColumnAfter: 'Add Column After',
                        addColumnBefore: 'Add Column Before',
                        addRowAfter: 'Add Row After',
                        addRowBefore: 'Add Row Before',
                        deleteColumn: 'Delete Column',
                        deleteRow: 'Delete Row',
                        deleteTable: 'Delete Table',
                        mergeCell: 'Merge Cell',
                        splitCell: 'Split Cell',
                        toggleHeaderRow: 'Toggle Header Row'
                    }
                }
            },
            workflowStatus: 'WORKFLOW STATUS',
            workflowTodo: 'TO DO',
            submissionTodo: {
                title: 'SUBMISSION',
                delayedAll: 'Delayed(All)',
                delayedMy: 'Delayed(My Submission)',
            }
        },
        case: {
            topmenu: {
                caselist: 'CASE LIST',
                warning: 'WARNING',
                emailLog: 'E-MAIL LOG'
            },
            duplicationCheck: {
                title: 'Duplication Check',
                caseNo: 'Case No. (C.1.1)',
                identifier: `发送者的（病例）安全报告唯一识别码 (C.1.1)`,
                recentDateTimeInHeader: `Date of Most Recent Information (C.1.5)`,
                recentDateTime: `收到本报告最新信息的日期 (C.1.5)`,
                reportType: `报告类型 (C.1.3)`,
                organisation: `报告者所在机构 (C.2.r.2.1)`,
                sponsorStudyNo: `申办者研究编号 (C.5.3)`,
                patientName: `患者（姓名或姓名首字母缩写） (D.1)`,
                investigationNumber: `患者医疗记录编号和记录编号的来源（研究编号） (D.1.1.4)`,
                age: `反应/事件发生时的年龄（数字） (D.2.2a)`,
                sex: `性别 (D.5)`,
                product: `DG_PRD_KEY`,
                meddraVersion: `编码反应/事件的MedDRA版本 (E.i.2.1a)`,
                reactionEvent: `反应/事件（MedDRA编码值） (E.i.2.1b)`,
                reactionEventColumnName: 'Reaction / Event',
                aeStartDate: `反应/事件开始日期 (E.i.4)`,
                dialogTitle: `Duplication Check`,
                noDuplicatedCases: `There are no duplicate cases.<br/>Are you sure you want to add a case?`,
                duplicatedCases: `There are duplicate cases. Are you sure you want to add a case?`,
                hasEmptyItemCases: `Cannot perform duplicate checks because active fields without data (including nullflavor) exist.
                                    <br/>Are you sure you want to add a case?`
            },
            kcd: {
                title: 'KCD ({version})',
                term: 'Korean Term',
                termEng: 'English Term',
                code: 'Code',
                selectVersion: 'Select KCD Version.'
            },
            dialog: {
                directInputMaxlengthExceed: '* The value you have entered exceeds the maximum data length.',
                alert: `* In case you need to specify your own code, please specify it and enter 'Input' button.`,
                directInputMinLength: '* Search term must be at least two characters in length.',
            },
            kims: {
                title: 'KIMS',
                kimsEng: 'KIMS English',
                kimsKor: 'KIMS Korean',
                manufacturer: 'Manufacturer',
                mfdsTerm: 'MFDS Korean',
                mfdsCode: 'MFDS Code',
            },
            mfdsProduct: {
                title: 'Retrieve Product',
                koreanTerm: 'Korean Term',
                englishTerm: 'English Term',
                code: 'Code',
            },
            mfdsSubstance: {
                title: 'Retrieve Substance',
                koreanTerm: 'Term',
                cancelStatus: 'Status',
                cancelDate: 'Date',
                code: 'Code',
            },
            meddra: {
                title: 'MedDRA Code ({version}/{searchLanguage})',
                lltName: 'LLT',
                ptName: 'PT',
                socName: 'SOC(Primary)',
                ime: 'IME',
                synoName: 'SYNONYM',
                imeFlag: 'Included in EMA IME List',
                selectVersion: 'Select MedDRA Version.',
                aiCodingNoticeText: 'The list above displays coding results recommended by the AI.'
            },
            whoart: {
                title: 'WHOART ({version})',
                inclTerm: 'Korean Term',
                termEng: 'English Term',
                arrn: 'ARRN',
                seq: 'SEQ',
                subSeq: 'SUB SEQ'
            },
            product: {
                title: 'Select Products',
                brandName: 'Brand Name',
                ipName: 'Pre-IP Name',
                sender: 'Sender',
            },
            CI: {
                caseNoChangeWarning: 'If C.1.1 is changed, the case will be disconnected from the follow-up cases. ',
                caseNoCanBeGeneratedOnlyOnce: `'Case no.' can be generated automatically only once.`,
            },
            RPSummaryRPSummary: {
                tableTitle: 'PRIMARY SOURCE(S) OF INFORMATION (REPEAT AS NECESSARY) (C.2.r) ',
                rowNo: 'No',
                primary: 'Primary',
                organisation: 'Reporter’s Organisation',
                givenName: `Reporter’s Given Name`,
                qualification: 'Qualification',
                country: 'Reporter’s Country',
                warning: 'Warning',
            },
            LRSummary: {
                rowNo: 'No',
                reference: 'Literature Reference(s)',
                documents: `Included Documents`,
                warning: 'Warning',
            },
            AESummary: {
                tableTitle: 'Reaction(s)/Event(s) (E.i)',
                reactionEvent: 'Reaction / Event',
                termHighlighted: 'Term Highlighted by the Reporter',
                seriousness: 'Seriousness',
                startDate: 'Date of Start',
                endDate: 'Date of End',
                outcome: 'Outcome',
                country: 'Country',
                warning: 'Warning'
            },
            AE: {
                selectAllNII: `Select All 'NI'`
            },
            DHSummary: {
                rowNo: 'No',
                nameOfDrugAsReported: 'Name of Drug as Reported',
                mpid: 'Medicinal Product Identifier(MPID)',
                startDate: 'Start Date',
                endDate: 'End Date',
                indication: 'Indication',
                reaction: 'Reaction',
                warning: 'Warning'
            },
            LBSummary: {
                rowNo: 'No',
                testDate: 'Test Date',
                testName: 'Test Name',
                testResultCode: 'Test Result(code)',
                testResult: 'Test Result',
                unstructuredData: 'Result Unstructured Data',
                comments: 'Comments',
                warning: 'Warning'
            },
            DGSummary: {
                rowNo: 'No',
                drugRole: 'Drug Role',
                productKeyName: 'DG_PRD_KEY',
                productName: 'Product Name',
                actionTaken: 'Action(s) Taken with Drug',
                warning: 'Warning'
            },
            minimumValueShouldBeEntered: 'The minimum value that should be entered in the page is not entered.',
            rowNoLabel: 'No',
            caseReportEmailLog: 'Case Report E-mail Log',
            sender: 'SENDER',
            receiver: 'RECEIVER',
            auditTrail: 'Audit trail',
            erase: 'Erase',
            restore: 'Restore',
            notation: 'Notation',
            emailLogRecipientName: 'Name',
            emailLogRecipientEmail: 'Email',
            saveBeforeAction: 'Please save the page modified.',
            selectedReportUnknown: 'You have to choose a report.',
            deleteReasonDialogContent: 'Delete Case -',
            restoreReasonDialogContent: 'Restore Case -',
            deleteListReasonDialogContent: `<strong>Delete Case -</strong>
                                            <br>Do you want to save your changes?
                                            <br>Please enter your reason why did changed.`,
            restoreListReasonDialogContent: `<strong>Restore Case -</strong>
                                            <br>Do you want to save your changes?
                                            <br>Please enter your reason why did changed.`,
            deleteRowReasonDialogContent: `<strong>Delete Row -</strong>
                                            <br>Do you want to save your changes?
                                            <br>Please enter your reason why did changed.`,
            restoreRowReasonDialogContent: `<strong>Restore Row -</strong>
                                            <br>Do you want to save your changes?
                                            <br>Please enter your reason why did changed.`,
            warning: {
                hasNotPermission: 'The requested information doesn’t exist or you don’t have required permissions. Contact your system administrator.',
                emptyCaseList: 'Please select one or more cases.',
            },
            drug: {
                title: 'Drug(s) Information (G.k)'
            },
            caseReportEmailDialog: {
                title: 'Case Report E-mail',
                sender: 'SENDER',
                receiver: 'RECEIVER',
                emailList: 'EMAIL LIST',
                consigneeList: 'CONSIGNEE LIST',
                newEmail: 'NEW E-MAIL',
                comment: 'COMMENT',
                password: 'PASSWORD',
                na: 'N/A',
                duplicateEmail: 'The e-mail address you specified is already registered with consignee list or email list.',
                notation: 'NOTATION',
                orientation: 'ORIENTATION',
                dataOrdering : 'DATA ORDERING',
            },
            caseReportDownloadDialog: {
                title: 'Case Report Download',
                notation: 'NOTATION',
                orientation: 'ORIENTATION',
                dataOrdering : 'DATA ORDERING',
            },
            edqm: {
                df: {
                    title: 'Select Dose Form',
                    doseForm: 'Dose Form'
                },
                roa: {
                    title: 'Select Route of Administration',
                    routeOfAdministration: 'Route of Administration'
                }
            },
            whodd: {
                caseWhoddSelectDialog: {
                    title: '{version}',
                    medicinalProductID: 'Medicinal Product ID',
                    drugCode: 'Drug Code',
                    drugName: 'Drug Name',
                    nameSpecifier: 'Name Specifier',
                    ingredients: 'Ingredients',
                    generic: 'Generic',
                    preferred: 'Preferred',
                    country: 'Country',
                    mah: 'MAH',
                    pharmForm: 'Pharm Form',
                    strength: 'Strength',
                    preferredName: 'Preferred Name',
                    selAtcCode: 'Sel ATC Code',
                    selAtcName: 'Sel ATC Name',
                    atcCode: 'ATC Code',
                    atcName: 'ATC Name',
                    alert: '* Enter two or more characters for Korean and three or more for English. Enter two or more characters for numbers.'
                },
                caseWhoddCasSelectDialog: {
                    substanceName: 'Substance Name',
                    casNumber: 'Cas Number'
                },
                options: {
                    genericOrPreferred: 'Generic or Preferred',
                    genericAndPreferred: 'Generic And Preferred',
                    exactMatch: 'Exact Match'
                },
                aiCodingNoticeText: 'The list above displays coding results recommended by the AI.',
            },
            idf: {
                caseIdfSelectDialog: {
                    drugCode: 'Drug Code',
                    frequencyCategory: 'Frequency Category',
                    useCategory: 'Use Category 2',
                    drugName: 'Drug Name',
                    drugNameEng: 'Drug Name (Eng)',
                    genericName: 'Generic Name',
                    dosageForm: 'Dosage Form',
                    dosageFormCode: 'Dosage Form Code',
                    maintenanceFlag: 'Maintenance Flag'
                }
            },
            nsde: {
                caseNsdeSelectDialog: {
                    title: 'NSDE',
                    itemCode: 'Item Code',
                    ndc11: 'NDC11',
                    propName: 'Proprietary Name',
                    doseForm: 'Dosage Form',
                    marketingCat: 'Marketing\nCategory',
                    appNumMonoId: 'Application Number\nor Monograph ID',
                    prdType: 'Product Type',
                    marketingStartDate: 'Marketing\nStart Date',
                    marketingEndDate: 'Marketing\nEnd Date',
                    bilUnit: 'Billing Unit',
                    inactiveDate: 'Inactivation\nDate',
                    reactiveDate: 'Reactivation\nDate',
                }
            },
            unii: {
                caseUniiSelectDialog: {
                    title: 'UNII',
                    name: 'Name',
                    type: 'Type',
                    unii: 'UNII',
                    displayName: 'Display Name',
                }
            },
            deviceCode: {
                caseDeviceCodeSelectDialog: {
                    problemTitle: 'FDA Device Problem Code',
                    componentTitle: 'FDA Device Component Code',
                    level1Term: 'Level 1 Term',
                    level2Term: 'Level 2 Term',
                    level3Term: 'Level 3 Term',
                    fdaCode: 'FDA Code',
                    imdrfCode: 'IMDRF Code',
                }
            },
            re: {
                distributionHistoryTitle: 'Distribution History',
                historyType: 'Type',
                rptType: 'Report Type',
                receiver: 'Receiver',
                batchNo: 'Batch No.(ACK.A.1)',
                userId: 'User',
                historyDate: 'Date',
                ackCreationTime: 'Acknowledged Date'
            },
            wf: {
                currentStatus: 'Current Status',
                routeToNextStatus: 'Route to Next Status',
                role: 'Role',
                comments: 'Comments',
                no: 'No.',
                statusFrom: 'Status (From)',
                roleFrom: 'Role (From)',
                userFrom: 'User (from)',
                statusTo: 'Status (to)',
                roleTo: 'Role (to)',
                userTo: 'User (to)',
                dateOfMostRecent: 'Date of Most Recent',
                dueDate: 'Due date',
                dDay: 'D-day',
                delay: 'Delay',
                user: 'User',
                dateTime: 'Date/Time',
            },
            narrativeSelectDialog: {
                title: 'Select Auto-narrative template',
                name: 'Template Name'
            }
        },
        coding: {
            topmenu: {
                whoddMpid: 'WHODD(MPID)',
                mfdsMpid: 'MFDS(MPID)',
                whoddSubstance: 'WHODD(Sub ID)',
                mfdsSubstance: 'MFDS(Sub ID)',
            },
            updateSuccessMsg: '{result} out of {total} selected were successfully updated.'
        },
        caseinfo: {
            topmenu: {
                sender: 'SENDER',
                receiver: 'RECEIVER',
                product: 'PRODUCT',
                reporter: 'REPORTER',
                study: 'STUDY',
                narrative: 'NARRATIVE'
            },
            sender: {
                senderType: `发送者类型 (C.3.1)`,
                senderTypeLabelWidth: `190px`,
                senderOrganisation: `发送者所在机构 (C.3.2)`,
                senderJpnOrganisation: `送信者の組織 (日本語名称)`,
                senderOrganisationLabelWidth: `190px`,
                regulatoryListTitle: `Regulator's info. for Electronic Submission Gateway`,
                regulatoryAuthorityNo: 'No.',
                regulatoryAuthority: 'Regulatory Authority',
                regulatoryAuthorityDefault: 'Default',
                regulatoryMfdsSenderId: 'Sender Id',
                regulatoryMfdsAuthKey: 'AS2(Routing) ID',
                regulatoryNmpaCdeSenderId: 'CDE Sender Id',
                regulatoryNmpaCdrSenderId: 'CDR Sender Id',
                personForSendingTheReport: `负责传输报告的人员 (C.3.3)`,
                personForSendingNo: 'No.',
                senderDepartment: `发送者所在部门 (C.3.3.1)`,
                senderTitle: `发送者的称谓 (C.3.3.2)`,
                senderGivenName: `发送者的名字 (C.3.3.3)`,
                senderMiddleName: `发送者的中间名 (C.3.3.4)`,
                senderFamilyName: `发送者的姓氏 (C.3.3.5)`,
                senderAddressFaxTelEmail: `发送者的地址、传真、电话和邮箱地址 (C.3.4)`,
                senderStreetAddress: `发送者的街道地址 (C.3.4.1)`,
                senderStreetAddressLabelWidth: `220px`,
                senderCity: `发送者所在城市 (C.3.4.2)`,
                senderCityLabelWidth: `220px`,
                senderStateOrProvince: `发送者所在州或省 (C.3.4.3)`,
                senderStateOrProvinceLabelWidth: `220px`,
                senderPostcode: `发送者的邮政编码 (C.3.4.4)`,
                senderPostcodeLabelWidth: `220px`,
                senderCountryCode: `发送者的国家代码 (C.3.4.5)`,
                senderCountryCodeLabelWidth: `220px`,
                senderTelephone: `发送者的电话号码 (C.3.4.6)`,
                senderTelephoneLabelWidth: `220px`,
                senderFax: `发送者的传真号码 (C.3.4.7)`,
                senderFaxLabelWidth: `220px`,
                senderEmail: `发送者的邮箱地址 (C.3.4.8)`,
                senderEmailLabelWidth: `220px`,
                Deleted: `Deleted`,
                DeletedLabelWidth: `220px`,
                defaultRowCannotBeDeleted: 'Items checked as default cannot be deleted.',
                defaultSenderIdRequired: 'This field is required.',
            },
            senderSelectDialog: {
                title: 'Select Sender'
            },
            multipleSendersSelectDialog: {
                title: 'Select Senders',
                itemSelected: '{count} item(s) Selected.',
            },
            receiver: {
                receiverType: 'Receiver Type',
                receiverName: 'Receiver Name',
                receiverId: 'Receiver ID',
                dayCountRule: 'Day Count Rule',
                nsaeSolicted: 'NSAE SOLICITED',
                nsaeNonSolicted: 'NSAE Non-SOLICITED',
                saeSolicted: 'SAE SOLICITED',
                saeNonSolicted: 'SAE Non-SOLICITED',
                deleted: 'Deleted',
                description: 'Description',
                day: 'Day',
                NA: 'Not applicable',
                consignee: {
                    title: 'Consignee',
                    no: 'No.',
                    name: 'Name',
                    phone: 'Phone',
                    email: 'E-mail',
                }
            },
            receiverSelectDialog: {
                title: 'Select Receiver'
            },
            product: {
                prdName: 'Pre-approval IP Name',
                brandName: 'Brand Name',
                originalManufacturer: 'Original Manufacturer',
                sender: 'Sender',
                description: 'Description',
                deleted: 'Deleted',
                productDrug: {
                    mpidVersion: 'MPID版本日期/编号 (G.k.2.1.1a)',
                    mpid: '医疗产品标识符（MPID） (G.k.2.1.1b)',
                    phpidVersion: 'PhPID版本日期/编号 (G.k.2.1.2a)',
                    phpid: '药品标识符（PhPID） (G.k.2.1.2b)',
                    mfdsMpidVersion: 'Medicinal Product Version (G.k.2.1.KR.1a)',
                    mfdsMpid: 'Medicinal Product ID (G.k.2.1.KR.1b)',
                    productName: '主要来源报告的药品名称 (G.k.2.2)',
                    country: '药品获得国的标识 (G.k.2.4)',
                    blind: '设盲的试验用药 (G.k.2.5)',
                    authNumber: '上市许可/申请编号 (G.k.3.1)',
                    authNationCode: '上市许可/申请国家 (G.k.3.2)',
                    authName: '持有者/申请者名称 (G.k.3.3)'
                },
                substance: {
                    title: 'G.k.2.3.r - 物质/指定物质标识符和规格（必要时重复',
                    no: 'No.',
                    substanceName: '物质/指定物质名称 (G.k.2.3.r.1)',
                    substanceNameLabelWidth: '240px',
                    substanceVersionDate: '物质/指定物质术语ID版本日期/编号 (G.k.2.3.r.2a)',
                    substanceVersionDateLabelWidth: '350px',
                    substanceTermId: '物质/指定物质术语ID (G.k.2.3.r.2b)',
                    substanceTermIdLabelWidth: '280px',
                    mfdsTidVer: 'Substance Version (G.k.2.3.r.1.KR.1a)',
                    mfdsTidVerLabelWidth: '250px',
                    mfdsTid: 'Substance ID (G.k.2.3.r.1.KR.1b)',
                    mfdsTidLabelWidth: '200px',
                    substanceStrength: '规格（数值） (G.k.2.3.r.3a)',
                    substanceStrengthLabelWidth: '240px',
                    substanceStrengthUnit: '规格（单位） (G.k.2.3.r.3b)',
                    substanceStrengthUnitLabelWidth: '200px',
                },
                prdNameOrBrandNameRequired: 'This field is required.',
                uploadTitle: 'Product Upload',
            },
            productSelectDialog: {
                title: 'Select Product'
            },
            multipleProductsSelectDialog: {
                title: 'Select Products',
                itemSelected: '{count} item(s) Selected.',
            },
            reporter: {
                reporterName: `报告者的名字 (C.2.r.1)`,
                reporterTitle: `报告者的称呼 (C.2.r.1.1)`,
                reporterTitleLabelWidth: `250px`,
                givenName: `报告者的名字 (C.2.r.1.2)`,
                givenNameLabelWidth: `250px`,
                middleName: `报告者的中间名 (C.2.r.1.3)`,
                middleNameLabelWidth: `250px`,
                familyName: `报告者的姓氏 (C.2.r.1.4)`,
                familyNameLabelWidth: `250px`,
                addressTitle: `报告者的地址和电话 (C.2.r.2)`,
                organisation: `报告者所在机构 (C.2.r.2.1)`,
                organisationLabelWidth: `250px`,
                department: `报告者所在部门 (C.2.r.2.2)`,
                departmentLabelWidth: `250px`,
                street: `报告者所在街道地址 (C.2.r.2.3)`,
                streetLabelWidth: `250px`,
                city: `报告者所在城市 (C.2.r.2.4)`,
                cityLabelWidth: `250px`,
                stateOrProvince: `报告者所在州或省 (C.2.r.2.5)`,
                stateOrProvinceLabelWidth: `250px`,
                postCode: `报告者的邮政编码 (C.2.r.2.6)`,
                postCodeLabelWidth: `250px`,
                telephone: `报告者的电话 (C.2.r.2.7)`,
                telephoneLabelWidth: `250px`,
                countryCode: `报告者的国家代码 (C.2.r.3)`,
                countryCodeLabelWidth: `250px`,
                qualification: `报告者资质 (C.2.r.4)`,
                qualificationLabelWidth: `250px`,
                primarySource: `基于监管目的的主要来源 (C.2.r.5)`,
                primarySourceLabelWidth: `250px`,
                deleted: 'Deleted',
                deletedLabelWidth: `250px`,
            },
            reporterSelectDialog: {
                title: 'Select Reporter'
            },
            study: {
                productName: 'Product Name',
                studyRegistration: {
                    title: `研究注册（必要时重复） (C.5.1.r)`,
                    no: `No.`,
                    registrationNumber: `研究注册编号 (C.5.1.r.1)`,
                    registrationCountry: `研究注册国家 (C.5.1.r.2)`,
                },
                studyName: `研究名称 (C.5.2)`,
                studyNumber: `申办者研究编号 (C.5.3)`,
                studyType: `发现该反应/事件时的研究的类型 (C.5.4)`,
                edcSync: `EDC Sync`,
                deleted: `Deleted`,
                reporter: {
                    title: `Reporter`,
                    no: `No.`,
                    organisation: `报告者所在机构 (C.2.r.2.1)`,
                    givenName: `报告者的名字 (C.2.r.1.2)`,
                    qualification: `报告者资质 (C.2.r.4)`,
                }
            },
            narrative: {
                name: 'Template Name',
                narrative: 'Auto Narrative',
                description: 'Description',
                deleted: 'Deleted'
            },
            multipleStudiesSelectDialog: {
                title: 'Select Studies',
                itemSelected: '{count} item(s) Selected.',
            },
            syncCdmsSelectDialog: {
                title: 'Select EDC Study',
                studyNameColumnLabel: 'EDC Study Name',
                protocolColumnLabel: 'EDC Protocol'
            },
            syncR3SelectDialog: {
                title: 'Select Safety R3 Study',
            },
            resetSyncDialog: {
                title: 'Confirm',
                content: `<strong>Reset sync status -</strong><br>Do you really want to reset the sync status(es)?
                          <br> Please enter the reason for resetting the sync status(es)`,
                required: 'Please enter the reason for resetting the sync status(es)'
            },
            syncOptionsDialog: {
                title: 'Confirm',
                content: 'Please select the criteria for creating a synchronized case.',
            },
            deselectedSubjectDialog: {
                title: 'Confirm',
                content: `For the following subject(s), there are Adverse Event(s) that are unchecked, even though the Sync column is No. <br/><br/>
                          {subjects} <br/>
                          Are you sure you want to proceed?`
            },
        },
        data: {
            topmenu: {
                export: 'EXPORT',
                dataset: 'DATA SET',
                import: 'IMPORT',
                history: 'HISTORY',
                library: 'LIBRARY',
            },
            dataSet: {
                menuLabel: 'EXPORT',
                selectDataSet: 'SELECT DATA SET',
                selectDomain: {
                    menuLabel: 'Select Domain',
                    dataSetDownload: 'DATA SET DOWNLOAD',
                    selectAll: 'Select All'
                }
            },
            export: {
                rptType: 'Report Type',
                sender: 'Sender',
                receiver: 'Receiver',
                pmdaReportType: '報告分類',
                selectPage: 'Select Page',
                selectItem: 'Select Item',
                condition: 'Condition',
                directInput: 'Direct Input',
                preview: 'Preview',
                caseCheckEmptyWarningMessage: 'Please set the select item condition.',
                selectLibraryDialog: {
                    title: 'Select Library',
                    libraryName: 'Library',
                    description: 'Description'
                },
                last: 'Last',
                reviewStatus: 'Review Status',
                workflowStatus: 'Workflow Status',
                notation: 'Notation'
            },
            import: {
                fileUpload: 'File Upload',
                fileType: 'File Type',
                caseReportType: 'Case Report Type',
                product: 'Product',
                searchFile: 'Search File',
                fileSizeLimitExceed: 'The maximum allowed file size is {unit}.',
                addReportDue: 'Add Report Due to RE page'
            },
            history: {
                warning: 'Warning'
            },
            library: {
                libraryDetail: {
                    libraryName: 'Library Name',
                    description: 'Description',
                    deleted: 'Deleted',
                    selectPage: 'Select Page',
                    selectItem: 'Select Item',
                    condition: 'Condition',
                    directInput: 'Direct Input'
                }
            }
        },
        monitoring: {
            topmenu: {
                monitoring: 'MONITORING',
                history: 'HISTORY'
            },
            monitoringDetail: {
                selectAction: 'Select Action',
                includeDataSource: 'Include Data Source',
                selectItem: 'Select Item',
                condition: 'Condition',
                directInput: 'Direct Input'
            }
        },
        submission: {
            topmenu: {
                submission: 'SUBMISSION',
                submissionCheckList: 'SUBMISSION CHECK LIST',
                history: 'HISTORY',
                caseHistory: 'CASE HISTORY'
            },
            tooltip: {
                delayed: `The status has been changed to “Delayed” because your report has been delayed <br/>
                          in receiving an ACK for more than 48 hours. <br/><br/>
                          Please contact the regulator for the reason for the delay.<br/><br/>
                          To manually change the status, click the (…) Icon.`
            },
            submissionDetail: {
                sender: 'Sender',
                receiver: 'Receiver',
                submissionStatus: 'No history of ACK.ACCEPT',
                reviewStatus: 'Review Status',
                submissionCheckButton: 'SUBMISSION CHECK',
                selectPage: 'Select Page',
                selectItem: 'Select Item',
                condition: 'Condition',
                directInput: 'Direct Input',
                workflowStatus: 'Workflow Status',
                notation: 'Notation'
            },
            submissionHistoryDetailList: {
                warning: 'Warning',
            },
            submissionCheckList: {
                no: 'No.',
                caseNo: 'Case No.',
                dateOfCreation: 'Date of Creation',
                confirmDialog: {
                    title: 'Confirm',
                    content:
                        `Are you sure you want to submit {cases}cases?<br />Please enter comments on the submission.`,
                },
            },
            history: {
                details: 'Details',
                updateDialog: {
                    title: 'Comments',
                    auditTrails: 'Audit Trail',
                },
            },
        },
        sync: {
            topmenu: {
                syncStudyList: 'STUDY LIST'
            },
            syncStudyDetail: {
                mappingRule: 'MAPPING RULE',
                syncList: 'SYNC LIST',
                summaryList: 'Summary List',
                no: 'No',
                cubeSAFETY: 'cubeSAFETY',
                page: 'Page',
                item: 'Item',
                sequence: 'Sequence',
                function: 'Function',
                value: 'Value',
                cubeCDMS: 'cubeCDMS',
                visit: 'Visit',
                pageVersion: 'Page Version',
                functionArgv: 'Function Argv.',
                codeConversion: 'CODE CONVERSION',
                setCubeCDMSItem: 'If code conversion is entered, only one cubeCDMS item can be set.'
            },
            selectCDMSItemDialog: {
                title: 'SELECT CDMS ITEM',
            },
            syncList: {
                caseSyncIsYesMsg: `If the 'CASE Sync' is Yes, you can not sync again.`
            },
            selectSyncDialog: {
                title: 'Sync Select',
                visit: 'Visit',
                cubeCdms: 'cubeCDMS',
                subjectNo: 'Subject No.',
                rowNo: 'Row No.',
                aeTerm: 'AE Term',
                status: 'Status',
                sae: 'SAE',
                sync: 'SYNC'
            }
        },
        admin: {
            topmenu: {
                user: 'USER',
                role: 'ROLE',
                rolepriv: 'ROLE & PRIVILEGE',
                settings: 'SETTINGS',
            },
            user: {
                userName: 'Name',
                userId: 'ID(E-mail)',
                phone: 'Phone',
                roles: 'Role',
                startDate: 'Start Date',
                endDate: 'End Date',
                description: 'Other Information',
                unblind: 'Unblind',
                senders: 'Sender',
                products: 'Product',
                studies: 'Study',
            },
            role: {
                no: 'No.',
                role: 'Role',
                description: 'Description',
                cannotCreateRole: 'You can not register more than 10 roles',
            },
            rolepriv: {
                menu: 'Menu',
                type: 'Type',
                privilege: 'Privilege'
            },
            settings: {
                timezone: 'Time Zone',
                meddraLang: 'MedDRA Language',
                meddraVer: 'MedDRA Version',
                companyLogo: 'Company Logo',
                ciomsOrientation: 'Orientation',
                ciomsDataOrdering: 'Data Ordering',
                notation: 'Notation',
                applyComments: 'Apply comments on element to exported xml',
                applySender: `Apply 'SENDER' of 'CASE INFO.' to imported cases`,
                defaultR2: 'Apply default values to imported R2 cases',
                appendix: 'Appendix',
                appendixNo: 'No.',
                appendixReceiver: 'Receiver',
                format: 'Number Setting',
                identifier: 'Identifier',
                sequence: 'Sequence Digit',
                sequenceType: 'Sequence Condition',
                formatItmes: 'Number Format',
                formatItemsTitle: 'Case Identification Number Setting(C.1.1 & C.1.8.1)',
                selectAtLeastOneReceiver: 'Please select at least one receiver.',
                sequenceDigitAndConditionRequired: `Please specify 'Sequence digit' and 'Sequence condition', if you want to add 'Sequence' to the number format.`,
                workflowConfiguration: 'Workflow Configuration',
                workflow: {
                    workflow: 'Workflow',
                    no: 'No.',
                    status: 'Status',
                    role: 'Role',
                    due: 'Due',
                    description: 'Description',
                    saved: 'Saved',
                    approval: 'Approval',
                },
                multipleRolesSelectDialog: {
                    title: 'Select Roles',
                },
                valueAlreadyExists: 'value already exists.',
                workflowMaxlengthExceed: 'Up to 10 workflow steps can be configured.',
                idfVersion: 'IDF Version'
            }
        },
        system: {
            topmenu: {
                companyList: 'COMPANY LIST'
            },
            companyDetail: {
                companyProperty: 'COMPANY PROPERTY',
                spnName: 'Organization Name',
                clientType: 'Type',
                country: 'Country',
                status: 'Status',
                userName: 'Name',
                email: 'ID(E-mail)',
                medicalCoding: 'Medical Coding',
                phone: 'Phone',
                description: 'Other information',
                studyMapping: 'STUDY MAPPING',
                studyMappingDetail: {
                    safetyR3Study: 'SAFETY R3 STUDY',
                    edcStudy: 'EDC STUDY'
                },
                userList: 'USER LIST',
                studyMappingAudittrail: {
                    targetStudy: 'Safety R3 Study',
                    sourceStudy: 'EDC Study'
                },
                idf: 'IDF'
            },
            caseInfo: {
                topmenu: {
                    receiver: 'RECEIVER'
                },
                receiver: {
                    header: 'Information on Receiver of Case Safety Report for PMDA',
                    organ: '受信者組織名 (J2.18.1)',
                    title: '受信者職名 (J2.18.2)',
                    familyName: '受信者姓 (J2.18.3)',
                    givenName: '受信者名 (J2.18.4)'
                }
            }
        },
        search: {
            topmenu: {
                data: 'DATA',
                submission: 'SUBMISSION'
            },
            data: {
                exportHistory: 'Export History',
                fileName: 'File Name'
            },
            submission: {
                submissionHistory: 'Submission History & Status',
                batchNo: 'Batch No.'
            }
        }
    }
};
